import { CurrentUserData } from "../../models";

interface StoredUserBase {
	userData: CurrentUserData;
}

export interface StoredCognitoUser extends StoredUserBase {
	idJWTToken: string;
	accessJWTToken: string;
	refreshJWTToken: string;
	type: "cognito";
}

export interface StoredSAMLUser extends StoredUserBase {
	jwt: string;
	expiry: number;
	type: "saml";
}

export type StoredUser = StoredSAMLUser | StoredCognitoUser;

export function isStoredSAMLUser(storedUser: StoredUser): storedUser is StoredSAMLUser {
	return storedUser.type === "saml";
}

export function isStoredCognitoUser(storedUser: StoredUser): storedUser is StoredCognitoUser {
	return storedUser.type === "cognito";
}

export interface AssociateSoftwareTokenResult {
	secretCode: string;
}
